import React from 'react';
import { Component, Container } from 'puzzle';
import { SECTION_DATA, SECTION_PROPS, STATUS_DATA } from './Types';
import StatusCard from "./StatusCard";

export class StatusSection extends Component<SECTION_PROPS, {}> {

  renderBody() {
    const { data, submissionData } = this.props;
    let mergedIndex;

    return (
      <>
        {data && data.map((section: SECTION_DATA, index: number) => {
          return (
            <React.Fragment key={`tp-submission-status-section-${index}`}>
              {section.subSections.map((subSection: STATUS_DATA, subSectionsIndex: number) => {
                mergedIndex = [index, subSectionsIndex].join('');
                return (
                  <div
                    className={'class-for-devs-refs'}
                    key={`tp-submission-status-subsection-${mergedIndex}`}
                  >
                    <h3
                      className={'tp-submission-title tp-text-semibold k-text-ellipsis'}
                      id={`tp-submission-title-${mergedIndex}`}
                    >
                      <span>
                        {section.sectionName}
                      </span>
                      <span
                        className="tp-space-left-half-1 tp-space-right-half-1 pd-separator"
                        aria-hidden="true"
                      >
                        |
                      </span>
                      <span className={'tp-color-light-LM'}>
                        {subSection.subSectionName}
                      </span>
                    </h3>
                    <Container
                      hBox
                      role="grid"
                      tabIndex={0}
                      ariaLabeledBy={`tp-submission-title-${mergedIndex}`}
                      className="tp-submission-grid"
                      key={`tp-submission-table-${mergedIndex}`}
                    >
                      <div role="rowgroup" className={'sr-only'}>
                        <Container
                          role="row"
                          vBox
                          className="tp-submission-grid-header-row tp-color-light-LM tp-space-right-1"
                        >
                          <Container
                            alignItemsEnd
                            className='k-text-nowrap tp-font-size-sm'
                            hBox
                            justifyContentEnd
                            role="columnheader"
                          >
                            {this.translate('phaseLabel')}
                          </Container>
                          <Container
                            alignItemsCenter
                            className='k-text-nowrap tp-font-size-sm'
                            hBox
                            justifyContentEnd
                            role="columnheader"
                          >
                            {this.translate('dueDateLabel')}
                          </Container>
                          <Container
                            alignItemsCenter
                            className='k-text-nowrap tp-font-size-sm'
                            hBox
                            justifyContentEnd
                            role="columnheader"
                          >
                            {this.translate('assignee')}
                          </Container>
                          <Container
                            alignItemsCenter
                            className='k-text-nowrap tp-font-size-sm'
                            hBox
                            justifyContentEnd
                            role="columnheader"
                          >
                            {this.translate('statusLabel')}
                          </Container>
                          <Container
                            alignItemsCenter
                            className='k-text-nowrap tp-font-size-sm'
                            hBox
                            justifyContentEnd
                            role="columnheader"
                          >
                            {this.translate('filesLabel')}
                          </Container>
                        </Container>
                      </div>
                      {subSection.phaseInfos && subSection.phaseInfos.map((phase: any, index: number) => {
                        const phaseInfosLength = subSection.phaseInfos.length;
                        return (
                          <StatusCard
                            submissionData={submissionData}
                            phase={phase}
                            index={index}
                            lastPhase={phaseInfosLength === index + 1}
                            sectionName={subSection.targetLanguage}
                            subsectionName={subSection.batchName}
                            sectionStatus={subSection.status}
                            submissionStatus={this.props.submissionStatus}
                            key={`tp-submission-status-card-${index}`}
                          />
                        )
                      })}
                    </Container>
                  </div>
                );
              })}
            </React.Fragment>
          )
        })}
      </>
    );
  }
}

export default React.memo(StatusSection);
